import { useMsal } from "@azure/msal-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const APPREG_SCOPE = import.meta.env.VITE_APPREG_SCOPE as string;

enum LoginType {
  MSAL_REDIRECT = "MSAL_REDIRECT",
}

export default function UnauthenticatedPage() {
  const { instance } = useMsal();
  
  const hasMultiple = instance.getAllAccounts().length > 1;

  const handleLogin = (loginType: LoginType) => {
    if (loginType === LoginType.MSAL_REDIRECT) {
      instance
        .loginRedirect({
          scopes: [APPREG_SCOPE],
          prompt: "select_account",
          ...(hasMultiple ? { prompt: "select_account" } : {}),
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  return (
    <div className="grid h-screen w-full">
      <Card className="mx-auto my-auto max-w-sm border border-brand">
        <CardHeader>
          <CardTitle className="text-2xl">Aanmelden</CardTitle>
          <CardDescription>
            Gebruik een van de volgende methoden om aan te melden.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            <Button
              variant="outline"
              className="w-full border border-brand"
              onClick={() => handleLogin(LoginType.MSAL_REDIRECT)}
            >
              Aanmelden met Microsoft
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
